/*
 * @Author: 肖玲
 * @Date: 2023-03-01 10:31:37
 * @LastEditTime: 2023-07-06 19:24:08
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-intelligent-clean\modules\dayReportRouter.js
 * 日报
 */
import store from '@/store'
import { getDetail } from '@/api/flowRule'
import { configurationGet } from '@/api/flow'
const dayReportRouter = [
  // 待核验数据
  {
    path: '/flowSystem/pending-check/:data_attr',
    name: 'flowSystemPendingCheck',
    component: () =>
      // import(
      //   /*webpackChunkName:"pending" */
      //   '@/views/flowSystem/dataHandling/PendingCheck.vue'
      // ), //待删除文件
      import(
        /*webpackChunkName:"pending" */
        '@/views/butterfly-flow-system/flow-direction-intelligent-clean/day-report/tobe-verified/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '智能清洗', //二级菜单
      title: '待核验',
    },
  },
  // 待处理数据
  {
    path: '/flowSystem/fs-pending-table',
    name: 'flowSystemPendingTable',
    component: () =>
      // import(
      //   /*webpackChunkName:"pending" */
      //   '@/views/flowSystem/dataHandling/PendingTable.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"pending" */
        '@/views/butterfly-flow-system/flow-direction-intelligent-clean/day-report/tobe-pending/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '智能清洗', //二级菜单
      title: '待处理',
    },
  },
  // 待处理数据2
  {
    path: '/flowSystem/fs-pending-table/:data_attr',
    name: 'flowSystemPendingTableTwo',
    component: () =>
      // import(
      //   /*webpackChunkName:"pending" */
      //   '@/views/flowSystem/dataHandling/PendingTable.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"pending" */
        '@/views/butterfly-flow-system/flow-direction-intelligent-clean/day-report/tobe-pending/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '智能清洗', //二级菜单
      title: '待处理',
    },
  },
  // 待处理表格 行业库档案调用记录
  {
    path: '/flowSystem/file-call-record/:data_attr',
    name: 'flowSystemFileCallRecord',
    component: () =>
      // import(
      //   /*webpackChunkName:"pending" */
      //   '@/views/flowSystem/dataHandling/FileCallRecord.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"pending" */
        '@/views/butterfly-flow-system/flow-direction-intelligent-clean/day-report/tobe-pending/IndustryFileRecord.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '流向清洗', //二级菜单
      title: '行业库档案调用记录',
      breadcrumb: [
        {
          title: '待处理',
          name: 'flowSystemPendingTable',
        },
      ],
    },
  },
  // 待处理表格 未匹配数据处理
  {
    path: '/flowSystem/manual-pending-table/:json/:data_attr',
    name: 'flowSystemManualPendingTable',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemManualPendingTable" */
      //   '@/views/flowSystem/dataHandling/ManualPendingData.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"flowSystemManualPendingTable" */
        '@/views/butterfly-flow-system/flow-direction-intelligent-clean/day-report/tobe-pending/Unmatched.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '智能清洗', //二级菜单
      title: '未匹配数据处理',
      breadcrumb: [
        {
          title: '待处理数据',
          name: 'flowSystemPendingTable',
        },
      ],
    },
  },
  // 待处理表格 云清洗页面
  {
    path: '/flowSystem/cloud-clean/:flow_cloud_clean_log_id/:data_attr',
    name: 'flowSysteCloudClean',
    component: () =>
      // import(

      //   /*webpackChunkName:"flowSystemManualPendingTable" */
      //   '@/views/flowSystem/dataHandling/ManualPendingData.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"flowSystemManualPendingTable" */
        '@/views/butterfly-flow-system/flow-direction-intelligent-clean/day-report/tobe-pending/CloudClean.vue'
        ), //新迁移文件
    meta: {
      SecondaryMenu: '智能清洗', //二级菜单
      title: '云清洗',
      breadcrumb: [
        {
          title: '待处理数据',
          name: 'flowSystemPendingTable',
        },
      ],
    },
  },
  // 待处理表格 未匹配数据处理   批量匹配
  {
    path: '/flowSystem/batch-match-data/:json/:data_attr',
    name: 'flowSystemManualBatchMatch',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemManualPendingTable" */
      //   '@/views/flowSystem/dataHandling/BatchMatchData.vue'
      // ),   待删除文件
      import(
        /*webpackChunkName:"flowSystemManualPendingTable" */
        '@/views/butterfly-flow-system/flow-direction-intelligent-clean/day-report/tobe-pending/BatchMatch.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '智能清洗', //二级菜单
      title: '批量匹配数据',
      breadcrumb: [
        {
          title: '待处理数据',
          name: 'flowSystemPendingTable',
        },
      ],
    },
  },

  // 待处理表格 异常数据处理
  {
    path: '/flowSystem/pending-table-batch/:data_attr/:dataType',
    name: 'flowSystemPendingTableBatch',
    component: () =>
      // import(
      //   /*webpackChunkName:"pending" */
      //   '@/views/flowSystem/dataHandling/PendingTableBatch.vue'
      // ), 待删除文件
      import(
        /*webpackChunkName:"pending" */
        '@/views/butterfly-flow-system/flow-direction-intelligent-clean/day-report/tobe-pending/UnusualPending.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '智能清洗', //二级菜单
      title: '异常数据处理',
      breadcrumb: [
        {
          title: '待处理',
          name: 'flowSystemPendingTable',
        },
      ],
    },
  },
  //待处理  异常数据处理  查看回收站
  {
    path: '/flowSystem/pending-table-batch-useless/:data_attr/:data_type',
    name: 'flowSystemPendingTableBatchUseless',
    component: () =>
      // import(
      //   /*webpackChunkName:"pending" */
      //   '@/views/flowSystem/dataHandling/PendingTableBatchUseless.vue'
      // ),   待删除文件
      import(
        /*webpackChunkName:"pending" */
        '@/views/butterfly-flow-system/flow-direction-intelligent-clean/day-report/tobe-pending/ViewRecycleBin.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '智能清洗', //二级菜单
      title: '查看回收站',
      breadcrumb: [
        {
          title: '待处理',
          name: 'flowSystemPendingTable',
        },
        {
          title: '异常数据处理',
          name: 'flowSystemPendingTableBatch',
        },
      ],
    },
  },
  // 待处理表格 异常数据处理 -- 更多数据
  {
    path: '/flowSystem/more-data/:parameter',
    name: 'flowSystemMoreData',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemMoreData" */
      //   '@/views/flowSystem/dataHandling/MoreData.vue'
      // ),   待删除文件
      import(
        /*webpackChunkName:"flowSystemMoreData" */
        '@/views/butterfly-flow-system/flow-direction-intelligent-clean/day-report/tobe-pending/MoreData.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '', //二级菜单
      title: '更多数据',
      breadcrumb: [
        {
          title: '待处理表格',
          name: 'flowSystemPendingTable',
        },
        {
          title: '异常数据处理',
          name: 'flowSystemPendingTableBatch',
        },
      ],
    },
  },
  // 待入库数据 清理后表格
  {
    path: '/flowSystem/pending-in-flow/:data_attr',
    name: 'flowSystemPendingInFlowTwo',
    component: () =>
      // import(
      //   /*webpackChunkName:"pending" */
      //   '@/views/flowSystem/dataHandling/PendingInFlow.vue'
      // ),   待删除文件
      import(
        /*webpackChunkName:"pending" */
        '@/views/butterfly-flow-system/flow-direction-intelligent-clean/day-report/tobe-warehoused/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '智能清洗', //二级菜单
      title: '待入库',
    },
    async beforeEnter (to, from, next) {
      await configurationGet(10).then((res) => {
        if (0 === res.status) {
          // TODO: 暂时隐藏-
          store.commit('setFlowSetting10', JSON.parse(res.data.setting))
          // store.commit('setFlowSetting10', {
          //   is_xs_audit: '2',
          //   is_cg_audit: '2',
          //   is_kc_audit: '2'
          // });
        }
      })
      await configurationGet(11).then((res) => {
        if (0 === res.status) {
          //TODO: 暂时隐藏-
          store.commit('setFlowSetting11', JSON.parse(res.data.setting))
          // store.commit('setFlowSetting11', {
          //   xs_enter_type: { type: '1', enter_type: 0 },
          //   cg_enter_type: { type: '1', enter_type: '2' },
          //   kc_enter_type: { type: 1, enter_type: 0 }
          // });
        }
      })
      next()
    },
  },
  // 待入库数据 清理后表格
  {
    path: '/flowSystem/pending-in-flow',
    name: 'flowSystemPendingInFlow',
    component: () =>
      // import(
      //   /*webpackChunkName:"pending" */
      //   '@/views/flowSystem/dataHandling/PendingInFlow.vue'
      // ),   待删除文件
      import(
        /*webpackChunkName:"pending" */
        '@/views/butterfly-flow-system/flow-direction-intelligent-clean/day-report/tobe-warehoused/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '智能清洗', //二级菜单
      title: '待入库',
    },
    async beforeEnter (to, from, next) {
      await configurationGet(10).then((res) => {
        if (0 === res.status) {
          // TODO: 暂时隐藏-
          store.commit('setFlowSetting10', JSON.parse(res.data.setting))
          // store.commit('setFlowSetting10', {
          //   is_xs_audit: '2',
          //   is_cg_audit: '2',
          //   is_kc_audit: '2'
          // });
        }
      })
      await configurationGet(11).then((res) => {
        if (0 === res.status) {
          //TODO: 暂时隐藏-
          store.commit('setFlowSetting11', JSON.parse(res.data.setting))
          // store.commit('setFlowSetting11', {
          //   xs_enter_type: { type: '1', enter_type: 0 },
          //   cg_enter_type: { type: '1', enter_type: '2' },
          //   kc_enter_type: { type: 1, enter_type: 0 }
          // });
        }
      })
      next()
    },
  },
  // 待入库数据 批量操作
  {
    path: '/flowSystem/pending-in-flow-batch/:date_type/:data_attr/:searchObj',
    name: 'flowSystemPendingInflowBatch',
    component: () =>
      // import(
      //   /*webpackChunkName:"pending" */
      //   '@/views/flowSystem/PendingInflowBatch.vue'
      // ),    待删除文件
      import(
        /*webpackChunkName:"pending" */
        '@/views/butterfly-flow-system/flow-direction-intelligent-clean/day-report/tobe-warehoused/BatchOperation.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '智能清洗', //二级菜单
      title: '批量操作',
      breadcrumb: [
        {
          title: '待入库',
          name: 'flowSystemPendingInFlow',
        },
      ],
    },
  },
]
export default dayReportRouter
